// Custom script to handle variant image changes
// Eksekusi script sebelum DOMContentLoaded untuk mencegah flicker
(function() {
  // Simpan URL gambar utama produk saat halaman dimuat
  let mainImageUrl = '';
  let mainImageAlt = '';
  let isFirstLoad = true;
  let hasVariantChanged = false;
  
  // Fungsi untuk mendapatkan gambar utama produk
  function getMainProductImage() {
    // Cari gambar utama produk dari carousel pertama (desktop atau mobile)
    const desktopImages = document.querySelectorAll('.xo-product-info-media-style3__slide img');
    const mobileImages = document.querySelectorAll('.xo-product-info-media-mobile__slide img');
    
    // Pilih set gambar yang tersedia (desktop atau mobile)
    const productImages = desktopImages.length > 0 ? desktopImages : mobileImages;
    
    if (productImages && productImages.length > 0) {
      mainImageUrl = productImages[0].getAttribute('src');
      mainImageAlt = productImages[0].getAttribute('alt');
      
      // Tambahkan kelas khusus untuk gambar utama
      productImages[0].classList.add('product-featured-media');
    }
  }
  
  // Fungsi untuk menangani perubahan varian
  function setupVariantChangeHandlers() {
    // Tangkap semua pemilih varian
    const variantSelectors = document.querySelectorAll('.xo-field-select-custom-variant__trigger, .xo-field-select-custom-option-variant');
    
    if (variantSelectors.length > 0) {
      variantSelectors.forEach(selector => {
        selector.addEventListener('click', function() {
          // Tandai bahwa varian telah diubah
          hasVariantChanged = true;
          
          // Biarkan tema menangani perubahan gambar varian secara default
          // Tema akan secara otomatis memperbarui gambar ke gambar varian
        });
      });
    }
    
    // Tambahkan tombol untuk kembali ke gambar utama
    // Cek container untuk desktop atau mobile
    const desktopContainer = document.querySelector('.xo-product-info-media-style3');
    const mobileContainer = document.querySelector('.xo-product-info-media-mobile');
    const productContainer = desktopContainer || mobileContainer;
    
    if (productContainer) {
      // Fungsi untuk mendapatkan teks tombol berdasarkan bahasa browser
      function getButtonText() {
        const lang = document.documentElement.lang || 'en';
        const translations = {
          'id': 'Tampilkan Gambar Utama',
          'en': 'Show Main Image',
          'fr': 'Afficher l\'image principale',
          'es': 'Mostrar imagen principal',
          'de': 'Hauptbild anzeigen',
          'it': 'Mostra immagine principale',
          'ja': 'メイン画像を表示',
          'ko': '메인 이미지 표시',
          'zh-CN': '显示主图',
          'ru': 'Показать основное изображение'
        };
        
        return translations[lang] || translations['en'];
      }
      
      const resetButton = document.createElement('button');
      resetButton.textContent = getButtonText();
      resetButton.className = 'reset-to-main-image';
      
      resetButton.addEventListener('click', function() {
        resetToMainImage();
        // Sembunyikan tombol setelah diklik
        this.style.display = 'none';
        // Reset flag varian berubah
        hasVariantChanged = false;
      });
      
      productContainer.appendChild(resetButton);
      
      // Tampilkan tombol reset hanya ketika varian telah diubah
      document.addEventListener('variantChanged', function() {
        resetButton.style.display = 'none';
        setTimeout(function() {
          resetButton.classList.add('visible');
        }, 100);
      });
      
      // Tambahkan event listener untuk perubahan varian dari sistem tema
      document.addEventListener('product:variant:change', function(event) {
        if (hasVariantChanged) {
          // Buat event kustom untuk menandai bahwa varian telah diubah
          const variantChangedEvent = new Event('variantChanged');
          document.dispatchEvent(variantChangedEvent);
        }
      });
    }
  }
  
  // Fungsi untuk mengatur ulang ke gambar utama
  function resetToMainImage() {
    if (mainImageUrl) {
      // Coba temukan slide pertama di desktop
      let firstSlide = document.querySelector('.xo-product-info-media-style3__slide img');
      
      // Jika tidak ditemukan di desktop, coba di mobile
      if (!firstSlide) {
        firstSlide = document.querySelector('.xo-product-info-media-mobile__slide img');
      }
      
      if (firstSlide) {
        firstSlide.setAttribute('src', mainImageUrl);
        if (mainImageAlt) {
          firstSlide.setAttribute('alt', mainImageAlt);
        }
      }
    }
  }
  
  // Fungsi untuk memastikan gambar utama ditampilkan saat halaman dimuat
  function ensureMainImageOnLoad() {
    // Jika ini adalah pemuatan pertama, pastikan gambar utama ditampilkan
    if (isFirstLoad) {
      // Eksekusi segera untuk mencegah flicker
      resetToMainImage();
      
      // Tambahkan pengaman dengan interval untuk memastikan gambar utama tetap tampil
      const ensureInterval = setInterval(function() {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
          resetToMainImage();
          isFirstLoad = false;
          clearInterval(ensureInterval);
        }
      }, 50);
      
      // Hentikan interval setelah 1 detik untuk mencegah loop tak terbatas
      setTimeout(function() {
        clearInterval(ensureInterval);
      }, 1000);
    }
  }
  
  // Inisialisasi
  getMainProductImage();
  setupVariantChangeHandlers();
  ensureMainImageOnLoad();
  
  // Mendeteksi perubahan varian melalui MutationObserver untuk semua carousel slides
  // Ini akan mendeteksi perubahan pada gambar produk yang disebabkan oleh perubahan varian
  function setupMutationObserver() {
    // Tunggu sedikit untuk memastikan DOM telah sepenuhnya dimuat
    setTimeout(function() {
      // Cek container untuk desktop dan mobile
      const desktopContainers = document.querySelectorAll('.xo-product-info-media-style3__slide');
      const mobileContainers = document.querySelectorAll('.xo-product-info-media-mobile__slide');
      
      // Gabungkan semua container yang ditemukan
      const allContainers = [...desktopContainers, ...mobileContainers];
      
      if (allContainers && allContainers.length > 0) {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if ((mutation.type === 'attributes' || mutation.type === 'childList') && hasVariantChanged) {
              // Buat event kustom untuk menandai bahwa varian telah diubah
              const variantChangedEvent = new Event('variantChanged');
              document.dispatchEvent(variantChangedEvent);
            }
          });
        });
        
        // Mulai mengamati perubahan pada semua container gambar produk
        allContainers.forEach(function(container) {
          observer.observe(container, { 
            attributes: true, 
            childList: true, 
            subtree: true 
          });
        });
      }
    }, 500);
  }
  
  // Panggil fungsi untuk mengatur MutationObserver
  setupMutationObserver();
  
  // Tambahkan event listener untuk memastikan gambar utama tetap tampil setelah semua resource dimuat
  window.addEventListener('load', function() {
    resetToMainImage();
    isFirstLoad = false;
  });
})();
